import { Circle, Page } from '@/components';
import { collateralColorPalette } from '@/theme/utils/collateralColorPalette';
import { Flex, Heading } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import HistoricTabs from './HistoricTabs';
import IlksTable from './IlksTable';
import OverviewKpis from './OverviewKpis';

export default function LegacyRWAPage() {
  const theme = useTheme();
  return (
    <Page
      title={
        <Flex gap="3xs" alignItems="center">
          <Circle
            size="3"
            color={collateralColorPalette(
              'legacyRwa',
              theme.colors.collateralColors
            )}
          />
          <Heading size="1">Legacy RWA</Heading>
        </Flex>
      }>
      <OverviewKpis daysAgo={1} />
      <HistoricTabs />
      <IlksTable daysAgo={1} />
    </Page>
  );
}
